import { useContext } from "react";
import AccordionNewUI from "../../../../components/common/v2/AccordionNewUI";
import { LoansContext } from "../../../../context/LoansContext";
import DocumentList from "./DocumentList";
import FileUpload from "./FileUpload";

export default function Documents(props: any) {
  const {
    loanDetails,
  } = useContext(LoansContext);

  const { isApplicationSubmitted, uploadDocument } = props;
  const renderLoanDetailsUI = () => {
    return (
      <div style={{ marginBottom: "16px" }}>
        <FileUpload uploadDocument={uploadDocument} loanDetails={loanDetails}/>
        <DocumentList documents={loanDetails.documents} dynamicConfig={props?.dynamicConfig}/>
      </div>
    );
  };

  return (
    <div>
      <AccordionNewUI
        label={"Documents"}
        isApplicationSubmitted={isApplicationSubmitted}
        renderUI={renderLoanDetailsUI}
      />
    </div>
  );
}
